import React, { useState } from 'react';
import { boardsAPI } from '../api/api';
import './Modal.css';

interface CreateColumnModalProps {
  boardId: number;
  onClose: () => void;
  onColumnCreated: () => void;
}

const CreateColumnModal: React.FC<CreateColumnModalProps> = ({ boardId, onClose, onColumnCreated }) => {
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!name.trim()) {
      setError('Название столбца обязательно');
      return;
    }

    setLoading(true);
    setError('');

    try {
      await boardsAPI.createColumn(boardId, name);
      onColumnCreated();
    } catch (err: any) {
      setError(err.response?.data?.error || 'Ошибка при создании столбца');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Добавить столбец</h2>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Название столбца *</label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
              placeholder="Например: В работе"
            />
          </div>
          {error && <div className="error">{error}</div>}
          <div className="modal-actions">
            <button type="submit" className="submit-btn" disabled={loading}>
              {loading ? 'Создание...' : 'Создать'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateColumnModal;


